import RecommendationsSectionSvg from './recommendations-section.svg';

export const RecommendationsSectionIcon = RecommendationsSectionSvg;
